<script setup>
import {route as routeFn} from 'ziggy-js';
import {useForm} from '@inertiajs/vue3';
import {AuthenticationCardLogo} from '@/Components/Brand';
import {InputError, InputLabel, PrimaryButton, TextInput} from '@/Components/Form';
import AuthLayout from '@/Layouts/AuthLayout.vue';
import {AuthenticationCard} from '@/Layouts/Partials';

defineProps({
    type: {
        type: String,
        required: true,
    },
});

const form = useForm({
    email: '',
});

const submit = () => {
    form.post(routeFn('password.email'));
};
</script>

<template>
    <AuthLayout :title="$t('Forgot Password')">
        <AuthenticationCard>
            <template #logo>
                <AuthenticationCardLogo />
            </template>

            <div class="mb-4 text-sm text-gray-600 dark:text-gray-400">
                {{
                    $t(
                        'Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.',
                    )
                }}
            </div>

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600 dark:text-green-400">
                {{ status }}
            </div>

            <form @submit.prevent="submit">
                <div>
                    <InputLabel name="email" :value="$t('Email')" />
                    <TextInput
                        v-model="form.email"
                        name="email"
                        type="email"
                        class="mt-1 block w-full"
                        required
                        autofocus
                        autocomplete="username" />
                    <InputError class="mt-2" :message="form.errors.email" />
                </div>

                <div class="flex items-center justify-end mt-4">
                    <PrimaryButton :class="{'opacity-25': form.processing}" :disabled="form.processing">
                        {{ $t('Email Password Reset Link') }}
                    </PrimaryButton>
                </div>
            </form>
        </AuthenticationCard>
    </AuthLayout>
</template>
